import { useState } from "react";
import { Bounce, ToastContainer } from "react-toastify";
import LeftNav from "./LeftNav";
import TopHeader from "./TopHeader";

/**
 * Shared shell for every signed-in page: sidebar, header and
 * the scrollable content area. Pages render only their own content as children,
 * so the chrome stays consistent and is changed in one place.
 */
export default function Layout({ nav, title, children, footer }: any) {

  const [drawer, setDrawer] = useState(false);

  return (
    <>
      {/* dvh rather than vh: on mobile browsers vh includes the collapsing
          address bar, which pushed the footer and header off-screen. */}
      <div className="flex flex-col h-screen h-[100dvh] bg-slate-100">

        <div className="flex flex-row grow min-h-0">

          <LeftNav nav={nav} className="hidden lg:flex" />

          {/* min-w-0 lets the content area shrink instead of forcing the page
              to scroll sideways when a child (a wide table) overflows. */}
          <main className="flex flex-col grow min-w-0">

            <TopHeader title={title} setNav={() => setDrawer(!drawer)} />

            <section className="thin-scroll grow overflow-y-auto overflow-x-hidden">
              {children}
            </section>

            {/* Optional action bar pinned below the scroll area (e.g. Buy Now). */}
            {footer && (
              <div className="shrink-0 border-t border-slate-200 bg-white/90 backdrop-blur-xl">
                {footer}
              </div>
            )}

          </main>

        </div>

      </div>

      {/* Mobile drawer: same nav, slid in from the left below the lg breakpoint. */}
      <div className="lg:hidden">

        {drawer && (
          <div
            className="z-40 bg-slate-900/60 backdrop-blur-sm fixed inset-0"
            onClick={() => setDrawer(false)}
          />
        )}

        <div className={`z-50 fixed top-0 h-screen w-[264px] shadow-2xl transition-all duration-300 ${drawer ? 'left-0' : 'left-[-100%]'}`}>
          <LeftNav nav={nav} onNavigate={() => setDrawer(false)} />
        </div>

      </div>

      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={true}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      />
    </>
  )
}
